import axios from '../config/axiosConfig';

const API_URL = '';

const siemImportService = {
  /**
   * Upload SIEM alert file for preview/parsing
   */
  uploadAlerts: async (projectId, file, format = 'auto') => {
    const formData = new FormData();
    formData.append('alertFile', file);
    formData.append('format', format);

    const response = await axios.post(
      `${API_URL}/siem-import/upload/${projectId}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
  },

  /**
   * Confirm import of selected alerts
   */
  confirmImport: async (projectId, { selectedAlerts, analyst, autoCorrelate = false }) => {
    const response = await axios.post(
      `${API_URL}/siem-import/confirm/${projectId}`,
      { selectedAlerts, analyst, autoCorrelate }
    );
    return response.data;
  },

  SUPPORTED_FORMATS: [
    { value: 'auto', label: 'Auto-Detect' },
    { value: 'splunk', label: 'Splunk' },
    { value: 'elastic', label: 'Elastic Security' },
    { value: 'sentinel', label: 'Microsoft Sentinel' },
    { value: 'crowdstrike', label: 'CrowdStrike Falcon' },
    { value: 'wazuh', label: 'Wazuh' },
    { value: 'csv', label: 'Generic CSV' }
  ]
};

export default siemImportService;
